import React, { useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../../assets/css/layout/admin/Sidebar.css';
import {
  LayoutDashboard,
  User,
  FileText,
  History,
  LogOut,
  GraduationCap
} from "lucide-react";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const scrollPosRef = useRef(0);

  // Click se pehle scroll position save karo
  const handleLinkClick = () => {
    if (menuRef.current) {
      scrollPosRef.current = menuRef.current.scrollTop;
    }
  };

  // Route change hone ke baad scroll position restore karo
  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.scrollTop = scrollPosRef.current;
    }
  }, [location.pathname]);

  const menuItems = [
    { path: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/admin/sub-admins", icon: LayoutDashboard, label: "Sub Admins" },
    { path: "/admin/Donorlist", icon: User, label: "Donors" },
    { path: "/admin/NGOlist", icon: User, label: "NGOs" },
    { path: "/admin/studentMGMT", icon: User, label: "Students" },
    { path: "/admin/donations", icon: FileText, label: "Donations" },
    { path: "/admin/donor-levels-rewards", icon: History, label: "Donor Levels & Rewards" },
    { path: "/admin/Report", icon: History, label: "Reports & Analytics" },
    { path: "/admin/support-system", icon: History, label: "Support System" },
    { path: "/admin/blog-management", icon: History, label: "Blog Management" },
    { path: "/admin/Disputes", icon: History, label: "Disputes" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <aside className="ads-sidebar">
      <Link to="/" className="ads-sidebar-logo">
        <div className="ads-logo-icon">
          <GraduationCap size={24} />
        </div>
        <span>Student Support Hub</span>
      </Link>

      <nav className="ads-sidebar-menu" ref={menuRef}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`ads-sidebar-link ${active ? "active" : ""}`}
              onClick={handleLinkClick}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="ssb-sidebar-logout">
        <button
          className="ssb-logout-btn"
          onClick={() => {
            localStorage.removeItem("adminEmail");
            localStorage.removeItem("adminPassword");
            localStorage.removeItem("adminData");
            navigate("/admin-login");
          }}
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;